import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #f4f5f7;
  border-bottom: 3px solid #b28767;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  @media (max-width: 600px) {
    padding: 0 8px;
    height: 60px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  height: 80px;
`;

const LogoImg = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  background: none;
  display: block;
  @media (max-width: 600px) {
    width: 48px;
    height: 48px;
  }
`;

const LogoText = styled.div`
  h1 {
    font-size: 20px;
    font-weight: 700;
    color: #222;
    margin: 0;
    letter-spacing: 1px;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  span {
    font-size: 12px;
    color: #888;
    display: block;
    @media (max-width: 600px) {
      font-size: 10px;
    }
  }
`;

const Nav = styled.nav`
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  gap: 40px;
  margin: 0;
  padding: 0;
`;

const NavLink = styled.a`
  color: #222;
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  transition: color 0.3s;
  position: relative;

  &:hover {
    color: #555;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background: #222;
    transition: width 0.3s;
  }

  &:hover::after {
    width: 100%;
  }
`;

const Header = () => {
  const [activeSection, setActiveSection] = useState("inicio");

  useEffect(() => {
    const handleScroll = () => {
      // Atualizar seção ativa baseado no scroll
      const sections = ["inicio", "sobre", "servicos", "escolas", "contato"];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { id: "inicio", label: "INÍCIO" },
    { id: "sobre", label: "SOBRE NÓS" },
    { id: "servicos", label: "SERVIÇOS" },
    { id: "features", label: "FUNCIONALIDADE" },
    { id: "contato", label: "CONTATO" },
  ];

  return (
    <HeaderContainer>
      <Container>
        <Logo>
          <LogoImg
            src="/logo.png"
            alt="Logo"
            draggable={false}
            style={{ minWidth: 60, minHeight: 60, maxWidth: 80, maxHeight: 80 }}
          />
          <LogoText style={{ marginLeft: 18 }}>
            <h1>PRISMA </h1>
            <span>Assessoria Educacional e Organizacional</span>
          </LogoText>
        </Logo>

        <Nav>
          <NavList>
            {navItems.map((item) => (
              <li key={item.id}>
                <NavLink
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.id);
                  }}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </NavList>
        </Nav>
      </Container>
    </HeaderContainer>
  );
};

export default Header;
